(() => {
  'use strict';
  const players = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-hero-video]').forEach(video => {
      if (players.has(video)) return;
      const source = video.querySelector('source');
      if (!source) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = window.matchMedia('(min-width: 761px)');
      const cleanups = [];
      let visible = true, destroyed = false;
      video.muted = true;
      video.autoplay = false;
      const fallback = () => video.classList.remove('is-playing');
      const listen = (target, event, handler) => {
        target.addEventListener(event, handler);
        cleanups.push(() => target.removeEventListener(event, handler));
      };
      const sync = () => {
        if (destroyed) return;
        video.poster = desktop.matches ? video.dataset.desktopPoster : video.dataset.mobilePoster;
        if (motion.matches || !visible || document.hidden) {
          video.pause();
          if (motion.matches) fallback();
          return;
        }
        const src = desktop.matches ? source.dataset.desktopSrc : source.dataset.src;
        if (!src) return;
        if (source.getAttribute('src') !== src) {
          fallback();
          source.setAttribute('src', src);
          video.load();
        }
        try { video.play()?.catch(fallback); } catch { fallback(); }
      };
      [motion, desktop].forEach(query => {
        if (query.addEventListener) listen(query, 'change', sync);
        else {
          query.addListener(sync);
          cleanups.push(() => query.removeListener(sync));
        }
      });
      listen(video, 'playing', () => { if (!motion.matches) video.classList.add('is-playing'); });
      listen(video, 'error', fallback);
      listen(source, 'error', fallback);
      listen(document, 'visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          sync();
        });
        observer.observe(video);
        cleanups.push(() => observer.disconnect());
      }
      players.set(video, () => {
        destroyed = true;
        video.pause();
        cleanups.forEach(cleanup => cleanup());
        players.delete(video);
      });
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-hero-video]').forEach(video => players.get(video)?.());
  });
})();
